import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import Display from './Display';

const DomainNameRegistration = ({
  title = 'Order Details',
  taskData: { skip = false, primary = '' } = {},
  onClose
}) => {
  const { formatMessage: fm } = useIntl();

  const sections = [
    {
      title: fm({ id: 'orderView.items.domainName' }),
      items: [{ content: skip ? fm({ id: 'orderView.items.domainNotRequested' }) : primary, xs: 12 }]
    }
  ];

  return (
    <Display
      onClose={onClose}
      sections={sections}
      title={title}
    />
  );
};

DomainNameRegistration.propTypes = {
  title: PropTypes.string,
  taskData: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired
};

export default DomainNameRegistration;
